/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Appointment_Not_BookableInputs */

const en_error_appointment_not_bookable = /** @type {(inputs: Error_Appointment_Not_BookableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The appointment cannot be booked as asked.`)
};

/**
* | output |
* | --- |
* | "The appointment cannot be booked as asked." |
*
* @param {Error_Appointment_Not_BookableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_appointment_not_bookable = /** @type {((inputs?: Error_Appointment_Not_BookableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Appointment_Not_BookableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_appointment_not_bookable(inputs)
});